import React from 'react';
import styles from '../SaleReportPage.module.scss';

function SectionHeader({ icon, title, locked, toggleEnabled, onToggle }) {
  const enabled = toggleEnabled !== false;

  return (
    <div className={styles.sectionHeader}>
      {icon && <span className={styles.sectionHeaderIcon}>{icon}</span>}
      <span className={styles.sectionHeaderTitle}>{title}</span>
      <div className={styles.sectionHeaderCtrls}>
        {locked && (
          <span className={styles.sectionHeaderLocked}>
            {typeof locked === 'string' ? locked : '필수 영역'}
          </span>
        )}
        {onToggle && (
          <label className={`${styles.sectionHeaderToggle} ${enabled ? styles.sectionHeaderToggleOn : ''}`}>
            <input
              type="checkbox"
              hidden
              checked={enabled}
              onChange={(e) => onToggle(e.target.checked)}
            />
            <span className={`${styles.toggleSwitch} ${enabled ? styles.toggleOn : ''}`} />
            <span className={styles.toggleText}>{enabled ? '포함됨' : '제외됨'}</span>
          </label>
        )}
      </div>
    </div>
  );
}

export default SectionHeader;
